module.exports = __webpack_public_path__ + "static/media/20.c3fae8cd.jpg";